import { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Loader2, KeyRound } from "lucide-react";
import { toast } from "sonner";

// Schermata bloccante mostrata al primo accesso (must_change_password): obbliga a impostare
// una nuova password personale prima di poter usare l'app.
export default function ForcePasswordChange() {
  const { refresh, logout } = useAuth();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("La password deve avere almeno 6 caratteri"); return; }
    if (pw !== pw2) { toast.error("Le password non coincidono"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { new_password: pw });
      toast.success("Password aggiornata");
      await refresh();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Operazione non riuscita");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4" data-testid="force-password-change">
      <form onSubmit={submit} className="w-full max-w-sm pgp-card p-6 space-y-4">
        <div className="flex items-center gap-2 text-amber-400">
          <KeyRound className="h-5 w-5" />
          <h1 className="font-head text-lg">Imposta una nuova password</h1>
        </div>
        <p className="text-sm text-slate-400">Per il primo accesso è necessario scegliere una password personale.</p>
        <div>
          <Label className="text-slate-300">Nuova password</Label>
          <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="fpc-password" minLength={6} required className="mt-1.5 bg-slate-900/60 border-slate-700" />
        </div>
        <div>
          <Label className="text-slate-300">Conferma password</Label>
          <Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="fpc-password2" minLength={6} required className="mt-1.5 bg-slate-900/60 border-slate-700" />
        </div>
        <Button type="submit" disabled={saving} data-testid="fpc-submit" className="w-full bg-amber-500 hover:bg-amber-600 text-[#0a0d14] font-semibold">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salva e continua"}
        </Button>
        <button type="button" onClick={logout} data-testid="fpc-logout" className="w-full text-xs text-slate-500 hover:text-slate-300">Esci</button>
      </form>
    </div>
  );
}
